module.exports = __webpack_public_path__ + "img/img01.3b3627a8.png";